export const emptySivi = {
    'tipoVeicoloLabel': '',
    'marcaModello': '',
    'denomComm': '',
    'cilindrata': '',
    'codAlimenta': '',
    'dataImmatricolazione': '',
    'codiceFiscale': ''
}

export const emptySita = {
    'numCompCopertura': undefined,
    'impresaDbLabel': '',
    'effettoCopertura': '',
    'scadenzaCopertura': '',
    'numPolizza': '',
    'effettoPolizza': '',
    'scadenzaPolizza': ''
}

export const emptyAtrc = {
    'codImpCTPLabel':'',
    'cognomeRagSocContr': '',
    'nomeContr': '',
    'dataScadContratto':'',
    'classeCuDa':'',
    'classeCuA':'',
    'numSinistriRC5Anni':undefined,
    'numSinistriRC2Anni':undefined
}